import * as React from 'react';
import Tab from '@mui/material/Tab';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import * as PXBColors from '@brightlayer-ui/colors';
import { AppBar, Box, Tabs } from '@mui/material';
import { SingleAlarm } from '..';
import withStyles from '@mui/styles/withStyles';
import { FiltersData, ManageAlarmsTabsEnum, isDataLoaded } from '../../../types';
import { SiteDevicesDataProvider } from '../../../data/DataProviders/SiteDevicesDataProvider';
import { DeviceMasterProvider } from '../../../data/DataProviders/DeviceMasterProvider';
import { SiteListProvider } from '../../../data/DataProviders/SiteListProvider';
import { Selectors } from '../../../selectors';
import { useDispatch, useSelector } from 'react-redux';
import { useAlarmFilterData } from '../../../data/DataProviders/AlarmFilterProvider';
import { GatewayDeviceListProvider } from '../../../data/DataProviders/GatewayDeviceListProvider';
import { Actions } from '../../../actions';
import { useLocationListData } from '../../../data/DataProviders/LocationListDataProvider';
import { sortList } from '../../../lib/manage-alarms-helpers';
import { DataIndicators } from '../../DataIndicators';

const AlarmsStyleTabs = withStyles({
    root: {
        color: 'black',
        height: 28,
        '& .contentBox.MuiTabs-root': {
            left: '25px',
        },
        '& .MuiTab-textColorPrimary.Mui-selected': {
            color: '#1976d2',
        },
        '& .MuiTab-textColorPrimary': {
            color: 'rgba(0, 0, 0, 0.54)',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: '#1976d2',
        },
    },
})(Tabs);

export const ManageAlarmsTabs: React.FC<{
    organizationId: string;
    userId: string;
}> = (props) => {
    const [value, setValue] = React.useState(0);
    const { t } = useLanguageLocale();
    const manageAlarmState = useSelector(Selectors.ManageAlarmsSelectors.filtersData);
    const locations = useLocationListData();
    const locationListData = locations[0];
    const alarmFilterData = useAlarmFilterData();
    const dispatch = useDispatch();
    const [filtersData, setFiltersData] = React.useState<any>({
        siteId: '',
        locationId: '',
        deviceType: '',
        gatewayId: '',
        type: ManageAlarmsTabsEnum.singlealarms,
    });

    const handleTabChange = (event: React.SyntheticEvent, newValue: number): any => {
        setValue(newValue);
    };

    React.useEffect(() => {
        alarmFilterData.getAlarmFilterData(props.organizationId, props.userId);
        const filtersDataObj: FiltersData = { ...manageAlarmState.filters };
        setFiltersData(filtersDataObj);
    }, [props]);

    React.useEffect(() => {
        if (isDataLoaded(locationListData) && isDataLoaded(alarmFilterData.alarmFilter)) {
            sortList(locationListData.value.locations, 'locationName');
            if (alarmFilterData.alarmFilter.value.userPreferences) {
                if (alarmFilterData.alarmFilter.value.userPreferences.locationId === '') {
                    const filtersDataObj: any = { ...filtersData };
                    filtersDataObj.locationId = locationListData.value.locations[0].locationId;
                    setFiltersData(filtersDataObj);
                    dispatch(Actions.ManageAlarmsActions.SetAlarmFilters(filtersDataObj));
                } else {
                    const filtersDataObj: any = { ...alarmFilterData.alarmFilter.value.userPreferences };
                    filtersDataObj.contextualDataId = alarmFilterData.alarmFilter.value.contextualDataId;
                    setFiltersData(filtersDataObj);
                    dispatch(Actions.ManageAlarmsActions.SetAlarmFilters(filtersDataObj));
                }
            } else {
                // new org and userid
                const newFiltersObj: any = { ...filtersData };
                newFiltersObj.locationId = locationListData.value.locations[0].locationId;
                setFiltersData(newFiltersObj);
                dispatch(Actions.ManageAlarmsActions.SetAlarmFilters(newFiltersObj));
            }
        }
    }, [locationListData, alarmFilterData]);

    function tabProps(index: number): any {
        return {
            id: `manage-alarms-tab-${index}`,
        };
    }

    return (
        <Box sx={{ width: '100%' }}>
            <AppBar
                position="sticky"
                style={{ color: PXBColors.black[500], background: PXBColors.white[50], zIndex: 500 }}
            >
                <AlarmsStyleTabs
                    indicatorColor="primary"
                    textColor="primary"
                    style={{ marginLeft: '0px', display: 'flex' }}
                    value={value}
                    onChange={handleTabChange}
                    aria-label=""
                >
                    <Tab label={t('MANAGEALARMS.SINGLETABLABEL')} {...tabProps(0)} />
                    {/* <Tab  label={t('MANAGEALARMS.BULKTABLABEL')} {...tabProps(1)} /> Not part for now*/}
                    {/* <div style={{ flex: '1 1 auto' }}>
                <IconButton style={{ marginLeft: 620, color: PXBColors.gray[500] }}>
                    <MuiIcons.Search />
                </IconButton>
                <IconButton style={{ marginLeft: 16, color: PXBColors.gray[500] }}>
                    <MuiIcons.EditNotifications />
                </IconButton>
            </div> */}
                </AlarmsStyleTabs>
            </AppBar>
            {isDataLoaded(locationListData) &&
                manageAlarmState.filters.locationId && (
                    <SiteListProvider locationId={manageAlarmState.filters.locationId}>
                        <GatewayDeviceListProvider
                            siteId={manageAlarmState.filters.siteId}
                            profileId={manageAlarmState.filters.gatewayTypeId}
                        >
                            <DeviceMasterProvider>
                                <SiteDevicesDataProvider
                                    siteId={manageAlarmState.filters.siteId}
                                    recursive={true}
                                    includeflag={true}
                                >
                                    <SingleAlarm value={value} index={0}></SingleAlarm>
                                </SiteDevicesDataProvider>

                                {/* <BulkAlarms value={value} index={1}></BulkAlarms> */}
                            </DeviceMasterProvider>
                        </GatewayDeviceListProvider>
                    </SiteListProvider>
                )}
            {!isDataLoaded(alarmFilterData.alarmFilter) && !manageAlarmState.filters.siteId && (
                <DataIndicators
                    errorMessage="Loading"
                    emptyMessage="Loading"
                    inline
                    data={alarmFilterData.alarmFilter}
                    emptyIcon="Devices"
                    isEmpty={false}
                    isDetailedInfo={false}
                />
            )}
        </Box>
    );
};
